import { FormControl, FormField, FormItem, FormLabel, FormMessage, Input } from '@cobliteam/ui/form';

const DriverNameInput = () => {
  return (
    <FormField name='name'>
      {({ field }) => (
        <FormItem className='w-full space-y-1'>
          <FormLabel>Nome do motorista*</FormLabel>
          <FormControl>
            <Input type='text' {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    </FormField>
  );
};

export default DriverNameInput;
